import createSlice from "admin/store/create-slice";

const stateSchema = {
    items: [],
    isFetching: false
};

const slice = createSlice({
    name: 'common',
    initialState: {
        comboBox: {
            category: stateSchema,
            specCategory: stateSchema,
            keyword: stateSchema,
            brand: stateSchema,
            user: stateSchema
        }
    },
    reducers: {
        comboBoxCategoriesRequested: state => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                category: {
                    ...state.comboBox.category,
                    isFetching: true
                }
            }
        }),
        comboBoxCategoriesReceived: (state, payload) => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                category: {
                    ...state.comboBox.category,
                    isFetching: false,
                    items: payload.data
                }
            }
        }),
        comboBoxCategoriesFailed: state => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                category: {
                    ...state.comboBox.category,
                    isFetching: false
                }
            }
        }),

        comboBoxSpecCategoriesRequested: state => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                specCategory: {
                    ...state.comboBox.specCategory,
                    isFetching: true
                }
            }
        }),
        comboBoxSpecCategoriesReceived: (state, payload) => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                specCategory: {
                    ...state.comboBox.specCategory,
                    isFetching: false,
                    items: payload.data
                }
            }
        }),
        comboBoxSpecCategoriesFailed: state => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                specCategory: {
                    ...state.comboBox.specCategory,
                    isFetching: false
                }
            }
        }),

        comboBoxKeywordsRequested: state => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                keyword: {
                    ...state.comboBox.keyword,
                    isFetching: true
                }
            }
        }),
        comboBoxKeywordsReceived: (state, payload) => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                keyword: {
                    ...state.comboBox.keyword,
                    isFetching: false,
                    items: payload.data
                }
            }
        }),
        comboBoxKeywordsFailed: state => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                keyword: {
                    ...state.comboBox.keyword,
                    isFetching: false
                }
            }
        }),

        comboBoxBrandsRequested: state => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                brand: {
                    ...state.comboBox.brand,
                    isFetching: true
                }
            }
        }),
        comboBoxBrandsReceived: (state, payload) => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                brand: {
                    ...state.comboBox.brand,
                    isFetching: false,
                    items: payload.data
                }
            }
        }),
        comboBoxBrandsFailed: state => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                brand: {
                    ...state.comboBox.brand,
                    isFetching: false
                }
            }
        }),

        comboBoxUsersRequested: state => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                user: {
                    ...state.comboBox.user,
                    isFetching: true
                }
            }
        }),
        comboBoxUsersReceived: (state, payload) => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                user: {
                    ...state.comboBox.user,
                    isFetching: false,
                    items: payload.data
                }
            }
        }),
        comboBoxUsersFailed: state => ({
            ...state,
            comboBox: {
                ...state.comboBox,
                user: {
                    ...state.comboBox.user,
                    isFetching: false
                }
            }
        }),
    }
});

const {
    comboBoxCategoriesRequested, comboBoxCategoriesReceived, comboBoxCategoriesFailed,
    comboBoxSpecCategoriesRequested, comboBoxSpecCategoriesReceived, comboBoxSpecCategoriesFailed,
    comboBoxKeywordsRequested, comboBoxKeywordsReceived, comboBoxKeywordsFailed,
    comboBoxBrandsRequested, comboBoxBrandsReceived, comboBoxBrandsFailed,
    comboBoxUsersRequested, comboBoxUsersReceived, comboBoxUsersFailed
} = slice.actions;

export default slice.reducer;

export const resetStore = () => ({ type: 'RESET_STORE' });

export const getCategories4ComboBox = excludeId => ({
    types: [comboBoxCategoriesRequested.type, comboBoxCategoriesReceived.type, comboBoxCategoriesFailed.type],
    method: 'get',
    url: '/api/category/get4combobox',
    payload: excludeId ? { excludeId } : null
});

export const getKeywords4ComboBox = () => ({
    types: [comboBoxKeywordsRequested.type, comboBoxKeywordsReceived.type, comboBoxKeywordsFailed.type],
    method: 'get',
    url: '/api/keyword/get4combobox'
});

export const getSpecCategories4ComboBox = () => ({
    types: [comboBoxSpecCategoriesRequested.type, comboBoxSpecCategoriesReceived.type, comboBoxSpecCategoriesFailed.type],
    method: 'get',
    url: '/api/speccategory/get4combobox'
});

export const getBrands4ComboBox = () => ({
    types: [comboBoxBrandsRequested.type, comboBoxBrandsReceived.type, comboBoxBrandsFailed.type],
    method: 'get',
    url: '/api/brand/get4combobox'
});

export const getUsers4ComboBox = () => ({
    types: [comboBoxUsersRequested.type, comboBoxUsersReceived.type, comboBoxUsersFailed.type],
    method: 'get',
    url: '/api/user/get4combobox'
});